interface TArgs {
  width: number
  height: number
  delimiter?: string
}

export const formatHeightWidth = ({ width, height, delimiter = 'x' }: TArgs): string => {
  return `${height}${delimiter}${width}`
}
